var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v("Olá! Vamos começar sua autoavaliação comportamental?"),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Analise os comportamentos")]),
      _c("p", [
        _vm._v(
          " Os comportamentos aparecerão na sua tela. Ao lado de cada um, aparecerá uma escala que vai de "
        ),
        _c(
          "span",
          {
            staticClass: "text-center info--text font-weight-medium text-lg-h6",
          },
          [_vm._v('"Nunca"')]
        ),
        _c(
          "span",
          { staticClass: "text-center font-weight-medium text-lg-h6" },
          [_vm._v(" a ")]
        ),
        _c(
          "span",
          {
            staticClass: "text-center info--text font-weight-medium text-lg-h6",
          },
          [_vm._v('"Sempre"')]
        ),
        _c(
          "span",
          { staticClass: "text-center font-weight-medium text-lg-h6" },
          [_vm._v(".")]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Selecione a frequência dos comportamentos")]),
      _c("p", [
        _vm._v(
          " Clique na estrela que representa a frequência que você apresentou o comportamento indicado durante os últimos doze meses. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("p", [
        _c("span", { staticClass: "info--text" }, [
          _vm._v(
            " Lembre-se! Essa avaliação ajudará a direcionar sua trilha de desenvolvimento. "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }